<template>
    <form novalidate>
        <!-- <button @click="changeLang()">{{ localeCode }}</button> -->
        <InputText
            v-model:inputValue="model.strFirstname"
            :inputLbl="lbl.register.form.firstName"
            :errorInfo="errInfo[0]"
            :isTextOnly="true"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :trim="true"
        ></InputText>

        <InputText
            v-model:inputValue="model.strLastname"
            :inputLbl="lbl.register.form.lastName"
            :errorInfo="errInfo[1]"
            :isTextOnly="true"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :trim="true"
        ></InputText>

        <DatePickerDropdown
            v-model:inputValue="model.strBirthDate"
            :inputLbl="lbl.register.form.dateOfBirth"
            :errorInfo="errInfo[2]"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            ref="dob"
        ></DatePickerDropdown>

        <InputRadioGroup
            v-model:inputValue="model.strGender"
            :inputLbl="lbl.register.form.gender"
            :errorInfo="errInfo[3]"
            :items="listGender"
            :cols="2"
            :isFirstSave="isFirstSave"
            ref="gender"
        ></InputRadioGroup>

        <InputEmail
            v-model:inputValue="model.strEmail"
            :inputLbl="lbl.register.form.email"
            :maxLength="50"
            :errorInfo="errInfo[4]"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :trim="true"
        ></InputEmail>

        <InputContactNumber
            :countryList="countryList"
            v-model:rawValue="model.rawContactNo"
            v-model:inputValue="model.strContactNumber"
            :inputLbl="lbl.register.form.mobileNo"
            :errorInfo="errInfo[5]"
            countryCode
            :maxLength="20"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            ref="mobileNo"
            :disabled="editMode"
        ></InputContactNumber>

        <InputDropdown
            ref="dropdownCountry"
            :itemList="countryList"
            itemTextKey="name"
            v-model:inputValue="model.strCountryCode"
            :inputLbl="lbl.register.form.countryName"
            :errorInfo="errInfo[6]"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :disabled="true"
            arrow
        ></InputDropdown>

        <template v-if="isThai">
            <InputDropdown
                ref="dropdownProvince"
                :itemList="provinceList"
                v-model:inputValue="model.strProvinceCode"
                :inputLbl="lbl.register.form.provinceName"
                :errorInfo="errInfo[7]"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                arrow
                :itemTextKey="provinceTextKey"
                itemValueKey="provinceCode"
            ></InputDropdown>
        </template>
        <template v-else>
            <InputText
                ref="provinceText"
                v-model:inputValue="model.strProvinceName"
                :inputLbl="lbl.register.form.provinceName"
                :errorInfo="errInfo[7]"
                :isTextOnly="true"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :trim="true"
            ></InputText>
        </template>
    </form>
</template>

<script>
import { FormHelper } from "@/helper/FormHelper"
import Locale from "@/helper/locale/Locale"
import LocaleMixin from "@/mixin/LocaleMixin"
// components
import InputText from "@/components/Input/label/InputText.vue"
import DatePickerDropdown from "@/components/Input/label/DatePickerDropdown.vue"
import InputEmail from "@/components/Input/label/InputEmail.vue"
import InputContactNumber from "@/components/Input/label/InputContactNumber.vue"
import InputRadioGroup from "@/components/Input/label/InputRadioGroup.vue"
import InputDropdown from "@/components/Input/label/InputDropdown.vue"
// model
import { RegisterModel } from "../model/RegisterModel"

//composable
import useAvailableRegion, { useProvinceDropdownList } from "@/composables/AvailableRegionComposable";

export default {
    name: "RegisterForm",
    props: {
        modalController: Object,
        editMode: Boolean,
    },
    mixins: [LocaleMixin],
    components: {
        InputText,
        DatePickerDropdown,
        InputEmail,
        InputContactNumber,
        InputRadioGroup,
        InputDropdown
    },
    data: function () {
        return {
            model: new RegisterModel().setDefault(),
            errInfo: FormHelper.genErrorInfo(8),
            isFirstSave: true
        }
    },
    computed: {
        isThai: function () {
            return this.model.strCountryCode == '66'
        },
        listGender: function () {
            return [
                { text: this.lbl.register.form.gender.labels.female, value: "female" },
                { text: this.lbl.register.form.gender.labels.male, value: "male" },
                { text: this.lbl.register.form.gender.labels.none, value: "notspecified", cols: 2 }
            ]
        },
        provinceTextKey: function () {
            if (this.localeCode == 1033) {
                return "provinceNameEN"
            }
            return "provinceName"
        }
    },
    watch: {
        // countryList: function (val) {
        //     console.log("country list change")
        //     this.$nextTick(() => {
        //         if (val.length > 0) {
        //             this.$refs.dropdownCountry.setValue(this.model.strCountryCode)
        //             // load once
        //             if (this.isThai) {
        //                 this.getProvinceList().then(() => {
        //                     this.setDefaultProvince()
        //                 })
        //             }
        //         }
        //     })
        // },
        "model.strCountryCode": function () {
            if (!this.isThai) {
                this.model.strProvinceCode = ''
                this.model.strProvinceName = ''
            } else {
                this.setDefaultProvince()
            }
        }
    },
    mounted: function () {
        // console.log(this.lbl.register.form.firstName)
        this.model.setIdToken()
        // default radio
        this.model.strGender = this.listGender[2].value
    },
    setup: function () {
        const { countryList } = useAvailableRegion(Locale.getLocaleCode())
        const { provinceList, getProvinceList } = useProvinceDropdownList()
        return {
            countryList,
            provinceList,
            getProvinceList
        }
    },
    methods: {
        setDefaultProvince: function () {
            // console.log("call set default")
            this.model.strProvinceCode = '10'

            // setTimeout(() => {
            //     if (this.isThai) {
            //         this.$refs.dropdownProvince.setValue(this.model.strProvinceCode)
            //     }
            // }, 100);

        },
        setValuesFromCache: function(){
            let updateModel = new RegisterModel()
            updateModel.setDefault()
            updateModel.loadCache()

            // console.log(updateModel)
            this.setValues(updateModel)
        },
        /**
         * @param {import("@/types/RegisterModel.d").RegisterModel} data
         */
        setValues: function (data) {
            // set data to model
            // console.log(data)

            this.model.strFirstname = data.strFirstname
            this.model.strLastname = data.strLastname
            this.model.strBirthDate = data.strBirthDate
            this.model.strGender = data.strGender
            this.model.strEmail = data.strEmail
            this.model.strCountryCode = data.strCountryCode
            this.model.strCountryName = data.strCountryName

            // set province

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.isThai) {
                        this.model.strProvinceCode = data.strProvinceCode
                        // this.$refs.dropdownProvince.setValue(this.model.strProvinceCode)

                        this.model.strProvinceName = data.strProvinceName
                    } else {
                        this.model.strProvinceName = data.strProvinceName
                    }
                }, 100);
            })


            // extract mobile country code
            let activeCC = this.countryList.find(x => data.strContactNumber.startsWith(x.value))
            if (activeCC != null) {
                this.model.strContactNumber = data.strContactNumber.replace(activeCC.value, "") // remove active country code from contact no.
                this.$refs.mobileNo.setValues(activeCC.value, this.model.strContactNumber)
            } else {
                // unknow case countryv code
                // set raw
                this.model.strContactNumber = data.strContactNumber
                // default as thai country code
                this.$refs.mobileNo.setValues("66", this.model.strContactNumber)
            }


            // console.log("call set value");

        },
        changeLang: function () {
            let currentLang = this.localeCode
            this.switchLang(currentLang == 1033 ? 1054 : 1033)
        },
        validateForm: function () {
            // console.log(this.errInfo)
            // let firstErr = FormHelper.validate(this.errInfo, true)
            // if(firstErr != true){ // false, object
            //     console.log(firstErr)
            // }
            // specific validate
            // this.$refs.gender.validateInput()

            let errs = FormHelper.filterError(this.errInfo)
            // if (errs.length > 0) {
            //     this.modalController.alertModal.clearModal()
            //         .setMsg(errs[0].msg)
            //         .show();
            // }
            // console.log(errs)
            return errs.length == 0
        },
        getData: function () {
            this.isFirstSave = false
            // set complete data before sending back to caller
            // countryname, province name
            this.model.strCountryName = this.countryList.find(x => x.value == this.model.strCountryCode).altValue
            if (this.isThai) {
                let province = this.provinceList.find(x => x.provinceCode == this.model.strProvinceCode)
                this.model.strProvinceName = province.provinceNameEN || province.provinceName
            } else {
                this.model.strProvinceCode = null // clear province code when select other country
            }

            // console.log(this.model)

            if (this.validateForm()) {
                return this.model
            } else {
                return null
            }
        }
    }
}
</script>
